import { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import "./PdfBook.scss";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import DownloadPDF from "./DownloadPDF";

const PdfBook = ({ pages, pageNumber, imgWidth, imgHeight, pdfUrl }) => {
  const [numPages, setNumPages] = useState(pageNumber);
  const [currentPage, setCurrentPage] = useState(0);
  const flipBookRef = useRef(null);

  const [pageDimensions, setPageDimensions] = useState({
    width: imgWidth,
    height: imgHeight,
  });

  const handleNextPage = () => {
    if (flipBookRef.current && flipBookRef.current.pageFlip) {
      flipBookRef.current.pageFlip().flipNext();
    } else {
      console.error("flipBookRef.current is not initialized properly");
    }
  };

  const handlePrevPage = () => {
    if (flipBookRef.current && flipBookRef.current.pageFlip) {
      flipBookRef.current.pageFlip().flipPrev();
    } else {
      console.error("flipBookRef.current is not initialized properly");
    }
  };

  const onFlip = (e) => {
    setCurrentPage(e.data);
  };

  return (
    <>
      <div className="Book">
        <HTMLFlipBook
          width={pageDimensions.width}
          height={pageDimensions.height} // Dinamička visina
          size="stretch"
          minWidth={300}
          maxWidth={1200}
          minHeight={300}
          maxHeight={1000}
          showCover={false}
          mobileScrollSupport={true}
          className="Flip-Book"
          onFlip={onFlip}
          ref={flipBookRef}
        >
          {pages.map((page, index) => (
            <div key={index} className="Book-Page">
              <img src={page.src} alt={page.alt} className="Book-Page-Image" />
            </div>
          ))}
        </HTMLFlipBook>
      </div>
      <div className="Catalog-Navigation">
        <p>
          Stranica {Math.ceil(currentPage) + 1} od {Math.ceil(numPages)}
        </p>

        <div className="Catalog-Buttons">
          <button
            onClick={handlePrevPage}
            className="Catalog-Button"
            disabled={currentPage === 0}
          >
            <LeftCircleOutlined />
          </button>
          <button
            onClick={handleNextPage}
            className="Catalog-Button"
            disabled={currentPage >= numPages - 1}
          >
            <RightCircleOutlined />
          </button>
        </div>
        <DownloadPDF pdfUrl={pdfUrl} />
      </div>
    </>
  );
};

export default PdfBook;
